export enum DeathRecordPayeeTypeIdEnum {
  Spouse = 1,
  Estate = 2,
  NewPayee = 3
}
